export const FILTER_OPTION_VALUE_CUSTOM = 'custom';
export const FILTER_RANGE_MULTIPLIER = 100;
export const FILTER_RANGE_DEFAULT = { minimum: 0, maximum: 0 };

export const TABLE_ROW_SIZE = 26;
export const TABLE_ROW_SIZE_MOBILE = 64;
export const TABLE_DEFAULT_HEIGHT = TABLE_ROW_SIZE * 45;
